import { render, staticRenderFns } from "./SolutionHeader.vue?vue&type=template&id=06d073c6&scoped=true"
import script from "./SolutionHeader.vue?vue&type=script&lang=js"
export * from "./SolutionHeader.vue?vue&type=script&lang=js"
import style0 from "./SolutionHeader.vue?vue&type=style&index=0&id=06d073c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d073c6",
  null
  
)

export default component.exports